import React from "react";
import { Image } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import "./PaywallPage.scss";
import PayWall from "../../../components/PayWall/PayWall";
import GhostButton from "../../../components/dashboard-page/GhostButton/GhostButton";
import useOnboardingSteps from "../../../hooks/useOnboardingSteps";
import { OnboardingSteps, ROUTES } from "../../../utils/constants";
import ChevronLeftCircleIcon from "../../../components/icons/ChevronLeftCircleIcon";
import ImageSigmaGamesLogo from "../../../images/sigma-games-logo.png";

export default function PaywallPage() {
  const navigate = useNavigate();
  const { goToStep } = useOnboardingSteps();
  const { t } = useTranslation("common");

  const exploreGames = () => goToStep(OnboardingSteps.EXPLORE_GAMES);

  return (
    <div className="paywall-page">
      <header className="page-header">
        <GhostButton
          onClick={() => goToStep(OnboardingSteps.VIEW_WELCOME)}
          className="p-0"
        >
          <ChevronLeftCircleIcon
            chevronColor="white"
            bgColor="#FFFFFF17"
            width={32}
            height={32}
          />
        </GhostButton>
        <Image src={ImageSigmaGamesLogo} width={115} />
        <button className="skip-btn" onClick={() => navigate(ROUTES.ROOT.HOME)}>
          {t("skip")}
        </button>
      </header>
      <PayWall handleSuccessfulSubscription={exploreGames} />;
    </div>
  );
}
